<template>
	<div class="filter-newsroom-event__filterbuttonarea">
		<button type="button" class="filter-newsroom-event__filterbutton" :class="item.classes" :data-js-id="item.id" :data-js-info="item.info" data-js-type="Period" data-js-item="js-filter-newsroom-event-filterButton">
			{{item.title}}
		</button>
	</div>
</template>
<script>
export default {
  	name: "FilterNewsroomEventButtonItem",
	props: ["item"],
  	components: {
  	},
  	computed: {
  	}
};
</script>
